module.exports = __webpack_public_path__ + "static/media/17.92f6972.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/17.wav
// module id = ALfh
// module chunks = 0